

























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {CustomPropertyGridProps} from '@/types/customProperty';

interface PageObj {
  page: number;
}

@Component
export default class CustomPropertyBottomContent extends Vue {

  @Prop({required: true})
  private gridProps!: CustomPropertyGridProps;

  @Prop({
    required: false,
    default: function() {
      return {};
    },
    type: Object
  })
  private readonly gridOptions?: {[propName: string]: any};

  @Prop({required: true, default: () => []})
  private readonly data!: [];

  @Prop({required: false, default: false, type: Boolean})
  private readonly fireClick?: boolean;

  @Prop({required: false, default: '', type: String})
  private readonly tableTitle?: string;

  get pageOptions() {
    return this.gridProps.pageOptions;
  }

  private afterCall: boolean = false;
  private options = {
    header: {
      height: 33
    },
    columnOptions: {
      minWidth: 50
    },
    minRowHeight: 31,
    rowHeight: 31,
    bodyHeight: 190,
    useClientSort: false,
    pageOptions: {
      perPage: 30,
      page: 1,
      totalCount: 0
    }
  };

  private bodyHeight = 480;

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : this.bodyHeight);
    const pagination = grid.invoke('getPagination') as any;
    if (pagination) {
      const pageState = {
        totalCount: this.pageOptions.totalCount,
        page: this.pageOptions.page,
        perPage: this.pageOptions.perPage - 0
      };
      grid.invoke('resetData', this.data as any, {pageState});
    } else {
      grid.invoke('resetData', this.data as any);
    }
  }

  private created() {
    if (this.gridOptions && Object.keys(this.gridOptions) && this.gridOptions.constructor === Object) {
      if (this.gridOptions.bodyHeight) {
        this.bodyHeight = this.gridOptions.bodyHeight;
      }
      Object.assign(this.options, this.gridOptions);
    }
  }

  private mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (event: any) => {
        this.$emit('searchBtnClick', event.page);
        event.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });
  }

}
